import { useState, useEffect, useContext, useCallback } from "react";
import { TaskContext } from "../components/TaskContext";
import { UserDataContext } from "../components/UserDataContext";
import { Row, Col, Container, Modal } from "react-bootstrap";
import AddIcon from "@mui/icons-material/Add";
import Button from "@mui/material/Button";
import TaskSettlementsAdd from "./TaskSettlementsAdd";
import TaskNettoPerformer from "./TaskNettoPerformer";
import DeleteIcon from "@mui/icons-material/Delete";
import Tooltip from "@mui/material/Tooltip";
import { marginBottom } from "../App";
import { apiRequest } from "../components/Config";

export default function TaskSettlements() {
  const { taskId } = useContext(TaskContext);
  const [moneyPosition, setMoneyPosition] = useState([]);
  const { userData } = useContext(UserDataContext);
  const [show, setShow] = useState(false);
  const [deleted, setDeleted] = useState(0);
  const [netto, setNetto] = useState({});
  const [nettoPzitb, setNettoPzitb] = useState(0);
  const [bruttoPzitb, setBruttoPzitb] = useState(0);
  const [bruttoPerformer, setBruttoPerformer] = useState(0);
  const [brutto, setBrutto] = useState(0);
  const [vat, setVat] = useState(0);
  const [vatPzitb, setVatPzitb] = useState(0);
  const [showAddPosition, setShowAddPosition] = useState(false);
  const [showNettoPerformer, setShowNettoPerformer] = useState(false);
  const [allVat, setAllVat] = useState(0);
  const [allNetto, setAllNetto] = useState(0);
  const [allNettoPerformer, setAllNettoPerformer] = useState(0);
  const [allBruttoPerformer, setAllBruttoPerformer] = useState(0);
  const [allBrutto, setAllBrutto] = useState(0);
  const [refreshKey, setRefreshKey] = useState(0);
  const [status, setStatus] = useState(0);

  const handleClose = () => setShow(false);
  const addedData = () => {
    // console.log("addedData");
    setRefreshKey((prev) => prev + 1);
  };
  const addedData1 = () => {
    // console.log("addedData1");
    setRefreshKey((prev) => prev + 1);
  };

  useEffect(() => {
    const fetchData = async () => {
      if (!userData) return;
      try {
        const response = await apiRequest(`moneyposition/${taskId}`, "GET");
        if (Array.isArray(response)) {
          setMoneyPosition(response);
          const totalSumNetto = response.reduce((accumulator, item) => {
            return accumulator + parseFloat(item.sumNetto);
          }, 0);
          setAllNettoPerformer(totalSumNetto);
          const totalSumBrutto = response.reduce((accumulator, item) => {
            return accumulator + parseFloat((item.sumNetto * item.vat) / 100);
          }, 0);
          setAllBruttoPerformer(totalSumBrutto);
        } else {
          console.error("Otrzymane dane nie są tablicą:", response.data);
        }
      } catch (error) {
        console.error(error.message);
      }
    };
    let interval;
    if (userData && userData.userId && taskId > 0) {
      fetchData();
      interval = setInterval(fetchData, 20000);
    }
    return () => clearInterval(interval);
  }, [userData, deleted, refreshKey]);

  useEffect(() => {
    if (netto.nettoPerformer > 0) {
      setAllNetto(parseFloat(nettoPzitb) + parseFloat(netto.nettoPerformer));
      setAllVat(parseFloat(vat) + parseFloat(vatPzitb));
      setAllBrutto(parseFloat(bruttoPerformer) + parseFloat(bruttoPzitb));
    } else {
      setAllBrutto(0);
      setAllVat(0);
      setAllNetto(0);
    }
  }, [netto]);
  //pobranie danych dot. całego Zlecenia
  useEffect(() => {
    const fetchData = async () => {
      if (!userData) return;
      try {
        const response = await apiRequest(`taskNetto/${taskId}`, "GET");
        setStatus(response[0].status);
        setNetto(response[0]);
        setNettoPzitb(
          parseFloat(
            response[0].nettoPerformer * (response[0].pzitbFactor / 100)
          ).toFixed(2)
        );
        setVat(
          parseFloat(
            response[0].nettoPerformer * (response[0].vat / 100)
          ).toFixed(2)
        );
        setBrutto(
          (
            parseFloat(response[0].nettoPerformer || 0) *
              (parseFloat(response[0].pzitbFactor || 0) / 100) +
            parseFloat(response[0].nettoPerformer || 0) +
            parseFloat(response[0].nettoPerformer || 0) *
              (parseFloat(response[0].vat || 0) / 100)
          ).toFixed(2)
        );
        setShowNettoPerformer(false);
      } catch (error) {
        console.log(error.message);
      }
    };

    fetchData();
  }, [userData, brutto, deleted, refreshKey]);

  //userData, brutto, deleted, addedData
  useEffect(() => {
    setBruttoPerformer(parseFloat(netto.nettoPerformer) + parseFloat(vat));
    setVatPzitb(
      parseFloat(parseFloat(nettoPzitb) * parseFloat(netto.vat / 100))
    );
    setBruttoPzitb(
      parseFloat(parseFloat(nettoPzitb) * parseFloat(netto.vat / 100)) +
        parseFloat(nettoPzitb)
    );
  }, [vat, deleted]);

  const handleShowAddPosition = () => {
    setShowAddPosition(!showAddPosition);
  };

  const handleShowNettoPerformer = () => {
    setShowNettoPerformer(!showNettoPerformer);
  };

  const handleDelete = useCallback(
    (id) => {
      setDeleted(id);
      setShow(true);
    },
    [addedData1]
  );

  const handleDeletePosition = async () => {
    if (!deleted || !userData) return;

    try {
      const response = await apiRequest("moneydelete", "POST", {
        settlementId: deleted,
      });
      //console.log("Data: ", response.data);

      setMoneyPosition((prev) => prev.filter((item) => item.id !== deleted));
      setDeleted(null);
      setShow(false);
    } catch (error) {
      console.error("Błąd podczas usuwania pozycji:", error);
    }
  };

  return (
    <div>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Potwierdzenie</Modal.Title>
        </Modal.Header>
        <Modal.Body>Czy na pewno usunąć tę pozycję?</Modal.Body>
        <Modal.Footer>
          <Button variant="outlined" onClick={handleClose}>
            Anuluj
          </Button>
          <Button variant="contained" onClick={handleDeletePosition}>
            Usuń
          </Button>
        </Modal.Footer>
      </Modal>

      {userData && userData.permId === "1" && status !== "8" && (
        <Button onClick={handleShowNettoPerformer} className="ramka-gradient">
          Aktualizuj wycenę
          <AddIcon />
        </Button>
      )}
      {showNettoPerformer &&
        (userData.permId === "1" || userData.permId === "3") && (
          <TaskNettoPerformer
            refreshData={() => setDeleted(null)}
            addedData1={addedData1}
          />
        )}
      {userData && (userData.permId === "1" || userData.permId === "3") && (
        <>
          <Row>
            <Col></Col>
            <Col>Netto:</Col>
            <Col>VAT:</Col>
            <Col>Brutto:</Col>
          </Row>
          <hr></hr>
          <Row style={{ marginBottom }}>
            <Tooltip title="Wynagrodzenie Wykonawcy">
              <Col>Wykonawca</Col>
            </Tooltip>
            <Col>{netto.nettoPerformer} zł</Col>
            <Col>{vat} zł</Col>
            <Col>{bruttoPerformer.toFixed(2)} zł</Col>
          </Row>
          <Row style={{ marginBottom }}>
            <Tooltip title="Marża PZITB">
              <Col>PZITB</Col>
            </Tooltip>
            <Col>{nettoPzitb} zł</Col>
            <Col>{vatPzitb.toFixed(2)} zł</Col>
            <Col>{bruttoPzitb.toFixed(2)} zł</Col>
          </Row>
          <hr></hr>

          <Row>
            <Col>Razem:</Col>
            <Col>{allNetto.toFixed(2)} zł</Col>
            <Col>{allVat.toFixed(2)} zł</Col>
            <Col>{allBrutto.toFixed(2)} zł</Col>
          </Row>
          <hr></hr>
          <Row>
            <Col md="4">Współczynnik PZITB: </Col>
            <Col>
              <b>{netto.pzitbFactor} [%]</b>
            </Col>
          </Row>
          <hr></hr>
        </>
      )}
      <hr></hr>
      <p className="p3">Rozliczenie zlecenia</p>
      <hr></hr>
      <Row>
        <Col md="1">
          <b>ID</b>
        </Col>
        <Col md="1">
          <b>Osoba</b>
        </Col>
        <Col md="1">
          <b>Opis</b>
        </Col>
        <Col md="1">
          <b>Netto - Wyk.:</b>
        </Col>
        <Col md="1">
          <b>VAT</b>
        </Col>
        <Col md="1">
          <b>Brutto:</b>
        </Col>
        <Col md="2">
          <b>Utworzył:</b>
        </Col>
        <Col md="2">Bank:</Col>
        <Col md="1"></Col>
      </Row>
      <hr></hr>
      {Array.isArray(moneyPosition) &&
        moneyPosition.map((item) => (
          <Row key={item.id}>
            <Col md="1">{item.id}</Col>
            <Col md="1">{item.person}</Col>
            <Col md="1">{item.taskDescription}</Col>
            <Col md="1">{item.sumNetto} zł</Col>
            <Col md="1">{item.vat}</Col>
            <Col md="1">
              {(
                parseFloat(item.sumNetto) *
                (1 + parseFloat(item.vat) / 100)
              ).toFixed(2)}{" "}
              zł
            </Col>
            <Col md="2">{item.fullName}</Col>
            <Col md="2">{item.bank}</Col>
            <Col md="1">
              <Button onClick={() => handleDelete(item.id)}>
                <DeleteIcon />
              </Button>
            </Col>
          </Row>
        ))}
      <hr></hr>
      <Row>
        <Col md="1">
          <b>RAZEM:</b>
        </Col>
        <Col md="1"></Col>
        <Col md="1"></Col>
        <Col md="2">{allNettoPerformer} zł</Col>
        <Col md="1"></Col>
        <Col md="2">{allBruttoPerformer} zł</Col>
      </Row>
      <hr></hr>
      {userData && status !== "8" && (
        <Button onClick={handleShowAddPosition}>
          Dodaj nową pozycję Zlecenia
          <AddIcon />
        </Button>
      )}
      {showAddPosition && (
        <TaskSettlementsAdd
          refreshData={() => setDeleted(null)}
          addedData={addedData}
        />
      )}
    </div>
  );
}
